export const roles = [
    "farm_owner", "farm_admin", "farm_manager", "employee", "driver", "advisor",
    "accountant", "viewer", "agriflow_admin", "agriflow_superadmin"
];
export const permissions = [
    "agriculture.access", "farms.read", "farms.create", "farms.update", "farms.archive",
    "farm_members.read", "farm_members.invite", "farm_members.update", "farm_members.remove",
    "campaigns.read", "campaigns.create", "campaigns.update", "campaigns.close",
    "fields.read", "fields.create", "fields.update", "fields.archive", "fields.import", "fields.export",
    "crops.read", "crops.create", "crops.update", "equipment.read", "equipment.create",
    "equipment.update", "equipment.maintenance.read", "equipment.maintenance.manage",
    "workers.read", "workers.manage", "interventions.read", "interventions.create",
    "interventions.update", "interventions.validate", "interventions.correct",
    "products.read", "products.create", "products.update", "stocks.read", "stocks.create",
    "stocks.adjust", "stocks.transfer", "stocks.inventory", "stocks.export",
    "documents.read", "documents.upload", "documents.update", "documents.download",
    "planning.read", "planning.manage", "reports.read", "reports.create", "reports.export",
    "imports.create", "imports.read", "exports.create", "exports.read", "exports.download",
    "audit.read", "agriculture_admin.access", "agriculture_settings.manage",
    "agriculture_references.manage", "agriculture_integrations.manage"
];
const all = [...permissions];
const read = permissions.filter((permission) => permission.endsWith(".read") || permission === "agriculture.access");
export const rolePermissions = {
    farm_owner: all,
    farm_admin: all.filter((permission) => !permission.startsWith("agriculture_admin")),
    farm_manager: all.filter((permission) => !permission.startsWith("agriculture_admin") && !permission.includes("farm_members.remove")),
    employee: ["agriculture.access", "farms.read", "campaigns.read", "fields.read", "equipment.read", "workers.read", "interventions.read", "interventions.create", "planning.read", "documents.read"],
    driver: ["agriculture.access", "farms.read", "fields.read", "equipment.read", "interventions.read", "interventions.create", "planning.read"],
    advisor: [...read, "reports.create", "reports.export"],
    accountant: ["agriculture.access", "farms.read", "products.read", "stocks.read", "stocks.export", "reports.read", "reports.create", "reports.export", "documents.read"],
    viewer: read,
    agriflow_admin: all,
    agriflow_superadmin: all
};
export function hasPermission(role, permission) {
    return rolePermissions[role].includes(permission);
}
